import { useQuery } from "@tanstack/react-query";
import { ALTERATION_PREREQUISITES_QUERY_KEY } from "../contsants";
import { CampaignService } from "../services/Campaign.service";
import { ICampaignAlterationRequestPayload } from "../types";

export default function useGetAlterationPrerequisites (payload: ICampaignAlterationRequestPayload, enabled: boolean) {
    const {
        data: alterationPrerequisite,
        isFetching: isAlterationPrerequisiteFetching,
        error: alterationPrerequisiteError
    } = useQuery({
        queryKey: [...ALTERATION_PREREQUISITES_QUERY_KEY, payload],
        queryFn: () => CampaignService.alterationPrerequisite(payload),
        staleTime: 0,
        enabled: enabled,
        placeholderData: (data) => data
    });

    return {
        alterationPrerequisite,
        isAlterationPrerequisiteFetching,
        alterationPrerequisiteError
    };
}